<template>
  <v-layout row >
    <v-flex md12 >
      <v-card>
        <v-toolbar dense primary-title>
          <v-toolbar-title>
            {{$t('view.perfil.registros.label')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
            <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
          <v-card-text v-show="view.elem.showTable">
            <v-layout class="table-responsive">
              <v-flex md12>
                <table id="something" class="table table-striped table-bordered table-hover dataTables-example responsive" style="width:100%;" >
                  <thead>
                    <tr>
                      <th class="all">{{$t('view.plantillaCorreo.clave.th')}}</th>
                      <th class="all">{{$t('view.plantillaCorreo.descripcion.th')}}</th>
                      <th class="all">Acciones</th>
                    </tr>
                  </thead>
                </table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-flex >
  </v-layout>
</template>
<script>
import PlantillaCorreoAPI from "@/services/generales/plantillaCorreo";
import {handleResponseMessage} from '@/helpers/http-response-handler';
import tippy from 'tippy.js';

export default {
  data() {
    return {
      count:0
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
        }
      }
    }
  }
  , props:{
    pageLength:{
      default:10
      , type:Number
    }
    , responsive:{
      default:true
      , type:Boolean
    }
    , dom:{
      default:'<"html5buttons"B>lTfgitp'
    } 
  }
  ,methods: {
    async deleteRow(clave){
      try{
        const swalResponse = await this.$swal({
          title: this.$t('view.global.swal.disable.title')
          , text: this.$t('view.global.swal.disable.text')
          , type: this.$t('view.global.swal.disable.type')
          , showCancelButton: this.$t('view.global.swal.disable.showCancelButton')
          , confirmButtonColor: this.$t('view.global.swal.disable.confirmButtonColor')
          , cancelButtonColor: this.$t('view.global.swal.disable.cancelButtonColor')
          , confirmButtonText: this.$t('view.global.swal.disable.confirmButtonText')
          , cancelButtonText: this.$t('view.global.swal.disable.cancelButtonText')
          , reverseButtons: true
        });
        if(swalResponse.value){
          const response = await PlantillaCorreoAPI.disable({clave});
          handleResponseMessage({response: response,modulo:'PlantillaCorreo'});
        }
      }catch(error){
        console.log(error)
      }
    }
    , refreshData(){
      this.dataTable._fnAjaxUpdate();
    }
  }
  , computed:{}
  , components: {}
  // Instance Lifecycle Hooks
  , created(){
    //window.$('.dataTables-example').DataTable({});  
  }
  , mounted(){
    const vm = this;
    function emitEventDeleteRow(event){
      const {id} = this;
      vm.deleteRow(id)
      .then(response=>{
        vm.dataTable._fnAjaxUpdate();
      })
      .catch(console.log);
    }
    function emitEventEditRow(event){
      const {id} = this;
      vm.$emit('editRow', id);
    };
    function emitEventAuditRow(event){
      const {audit,dataDescripcion} = this;
      vm.$emit('auditRow', audit,dataDescripcion);
    };
    function newDeleteButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Desactivar");
      button.classList.add('btn', 'btn-action-delete', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-trash-o');
      //label settings
      label.appendChild(document.createTextNode('delete'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newEditButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Editar");
      button.classList.add('btn', 'btn-action-edit', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-pencil');
      //label settings
      label.appendChild(document.createTextNode('edit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newAuditButton(id,dataDescripcion,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Auditoría");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.audit = id || "";
      button.dataDescripcion = dataDescripcion || '';
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-database');
      //label settings
      label.appendChild(document.createTextNode('audit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    this.$nextTick(function(){
      
      vm.dataTable=window.$('#something').dataTable({     
        "bProcessing": true
        , "bServerSide": true
        , "bPaginate":true
        , "pageLength" : vm.pageLength
        , "responsive": true
        , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
        , "ajax":{
          "url": "/api/plantillaCorreo/list"
          , "type": "POST"
          , "async":true
          ,"headers":{
            "Authorization":`Bearer ${vm.$store.getters.getUserToken}`
          }
          , "data"    : function(data){}
          , "complete": function(response){}
          , "error"   : function(error){}
        }
        , "fnRowCallback": function( nRow, aData, iDisplayIndex, iDisplayIndexFull ) {
          nRow.cells[2].textContent = null;
          nRow.cells[2].appendChild(newEditButton(nRow.cells[0].innerText, emitEventEditRow));
          if(aData.status && vm.$userPermission.hasPermission('ROLE_MODIFICAR_CATALOGOS'))
            nRow.cells[2].appendChild(newDeleteButton(nRow.cells[0].innerText, emitEventDeleteRow));
          if(vm.$userPermission.hasPermission('ROLE_ACCESO_AUDITORIA'))
            nRow.cells[2].appendChild(newAuditButton(nRow.cells[0].innerText, aData['descripcion'],emitEventAuditRow));
        }
        , "fnDrawCallback": function (oSettings) {
          tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
        }
        , "aoColumns": [
          {
            "data":"clave"
            , "sClass":"text-center"
          }
          , {
            "data":"descripcion"
            , "sClass":"text-center"
          }
          , {
            "data":"status"
            , "sClass":"text-center"
          }
        ]
        , "aoColumnDefs":[
          {
            "aTargets": [ 2 ],
            "mData": "status",
            "searchable": false,
            "sorting": false,
            "orderable": false,
            "mRender": function ( data, type, full ) {
              return data;
            }
          }
        ]
      });

      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/generales/plantillaCorreo/DataTable.vue